import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68edec8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mengblack" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logoZone" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "adWords" }
const _hoisted_6 = { class: "text_title" }
const _hoisted_7 = { class: "text_content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  class: "downLoadZone"
}, "VIEW", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isShowPopUp)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ appAdZone: true, appAdZoneFixed: $props.isShowPopUp }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openApp($setup.randomGoodswriter[$setup.bannerListNum].url)))
      }, [
        _hoisted_1,
        _hoisted_2,
        _withDirectives(_createElementVNode("div", {
          class: "clickCloseAd",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.closeFn && $setup.closeFn(...args)), ["stop"]))
        }, _hoisted_4, 512), [
          [_vShow, $props.isShowPopUp]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.randomGoodswriter[$setup.bannerListNum].title), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString($setup.randomGoodswriter[$setup.bannerListNum].content), 1)
        ]),
        _hoisted_8
      ], 2))
    : _createCommentVNode("", true)
}